import { AdditionalFieldFilterItem, AdditionalFilterItem } from '@/types/service-response'

export class AdditionalFieldItem {
  public constructor (
    readonly designation: string,
    readonly id: number,
    readonly value: string,
    readonly parentType: number,
    readonly componentId: number,
    readonly groupId: number,
    readonly project: number | null
  ) {}

  public static createFromResponse (responseData: AdditionalFilterItem, groupId: number, project: number | null): Array<AdditionalFieldItem> {
    let result: Array<AdditionalFieldItem> = []
    if (responseData) {
      result = responseData.Items.map((item: AdditionalFieldFilterItem ) => {
        return new AdditionalFieldItem(
          item.FilterItemBezeichnung,
          item.FilterItemId,
          item.FilterItemInhalt,
          responseData.Feldtyp,
          responseData.Art,
          groupId,
          project
        )
      })
    }
    return result
  }
}